import React from "react";
import { Navigate } from "react-router-dom";
import UploadPage from "./Pages/UploadPage";
import LoadingPage from "./Pages/LoadingPage";
import ResultPage from "./Pages/ResultPage";
import HistoryPage from "./Pages/HistoryPage";
import NotFound from "./Components/NotFound";
import LoginPage from "./Pages/LoginPage";
import RegisterPage from "./Pages/RegisterPage";

type AppRoute = {
  path: string;
  element: React.ReactElement;
};

const AdminRoutes: AppRoute[] = [
  { path: "/", element: <UploadPage /> },
  { path: "/loading", element: <LoadingPage /> },
  { path: "/result", element: <ResultPage /> },
  { path: "/history", element: <HistoryPage /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/register", element: <RegisterPage /> },
  { path: "*", element: <NotFound /> },
];

export { AdminRoutes };
